import { StyleSheet, Platform } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  getButton: {
    width: 89,
    height: 32,
  },
  getButtonText: {
    color: Colors.white,
    fontSize: Fonts.size.regularSmall,
    fontWeight: 'bold',
    lineHeight: 20,
    letterSpacing: 0,
  },
  openButton: theme => ({
    width: 89,
    height: 32,
    backgroundColor: theme.colors.transparentColor,
    borderColor: theme.colors.borderColorFive,
    borderWidth: 1,
  }),
  openButtonText: theme => ({
    color: theme.colors.headerTitleColor,
    fontSize: Fonts.size.regularSmall,
    fontWeight: 'bold',
    lineHeight: 20,
    letterSpacing: 0,
  }),
  listStyle: {
    backgroundColor: Colors.transparent,
    shadowOpacity: 0,
    elevation: 0,
  },
  headerContainerStyle: {
    paddingHorizontal: 0,
  },
  headerStyle: {
    fontSize: 29.1,
    fontWeight: 'bold',
    lineHeight: 37.4,
    letterSpacing: 0,
    color: Colors.dark_grey,
  },
  itemsContainerStyle: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    borderRadius: 6,
    elevation: 5,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 8,
    shadowOpacity: 1,
    paddingVertical: 6,
  }),
  title: theme => ({
    fontSize: Fonts.size.input,
    lineHeight: 24,
    letterSpacing: 0,
    color: theme.colors.headerColor,
    marginTop: Platform.OS === 'ios' ? 3 : 0,
  }),
  listItemContainerStyle: theme => ({
    paddingVertical: 6,
    paddingHorizontal: 0,
    marginHorizontal: 15,
    borderColor: Colors.mono2,
    borderTopWidth: 0,
    borderBottomWidth: 1,
  }),
  lastListItemContainerStyle: {
    borderBottomWidth: 0,
  },
});
